'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function Page(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 1024 1024' }, props),
    React.createElement('path', { d: 'M236.864 64h472.96L896 261.12V848c0 61.856-54.72 112-114.848 112H236.832C176.768 960 128 909.856 128 848v-672C128 114.144 176.736 64 236.864 64zM672 128v133.856a26.144 26.144 0 0 0 26.144 26.144H832l-160-160z m106.656 768c29.44 0 53.344-24.576 53.344-54.848V347.424h-160c-29.44 0-53.344-24.544-53.344-54.848V128H245.344C215.904 128 192 152.576 192 182.848v658.304C192 871.424 215.872 896 245.344 896h533.312z' })
  );
}
Page.displayName = 'Page';

module.exports = Page;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/page.js
// module id = 196
// module chunks = 0